export const GET_TRANSLATIONS = "GET_TRANSLATIONS";
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const GET_IDENTIFY = "GET_IDENTIFY";
export const GET_IDENTIFY_SUCCESS = "GET_IDENTIFY_SUCCESS";
export const GET_IDENTIFY_FAIL = "GET_IDENTIFY_FAIL";
export const GET_IS_LOGGED_IN = "GET_IS_LOGGED_IN";
export const GET_IS_LOGGED_IN_SUCCESS = "GET_IS_LOGGED_IN_SUCCESS";
export const GET_IS_LOGGED_IN_FAIL = "GET_IS_LOGGED_IN_FAIL";
export const SET_ACTIVE_WORKSPACE_UUID = "SET_ACTIVE_WORKSPACE_UUID";
export const SET_CHATWOOT_UNREAD_MESSAGES = "SET_CHATWOOT_UNREAD_MESSAGES";
export const GET_WORKSPACES_LIST = "GET_WORKSPACES_LIST";
export const GET_WORKSPACES_LIST_SUCCESS = "GET_WORKSPACES_LIST_SUCCESS";
export const GET_WORKSPACES_LIST_FAIL = "GET_WORKSPACES_LIST_FAIL";
export const SET_WEBSOCKET = "SET_WEBSOCKET";
export const CLEAR_WEBSOCKET = "CLEAR_WEBSOCKET";
export const GET_CREATOR_DISCOVERY_TOOL_URL = "GET_CREATOR_DISCOVERY_TOOL_URL";
export const GET_CREATOR_DISCOVERY_TOOL_URL_SUCCESS =
  "GET_CREATOR_DISCOVERY_TOOL_URL_SUCCESS";
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const SET_PDF_READY_MODAL_DATA = "SET_PDF_READY_MODAL_DATA";
export const DROP_NOTIFICATION = "DROP_NOTIFICATION";
export const SET_SETTINGS_MODAL_DATA = "SET_SETTINGS_MODAL_DATA";
export const SET_HOW_IT_WORKS_MODAL_DATA = "SET_HOW_IT_WORKS_MODAL_DATA";

export const GET_WORKSPACE_TEAMS_LIST = "GET_WORKSPACE_TEAMS_LIST";

export const GET_WORKSPACE_TEAMS_LIST_SUCCESS =
  "GET_WORKSPACE_TEAMS_LIST_SUCCESS";

export const GET_WORKSPACE_TEAMS_LIST_FAIL = "GET_WORKSPACE_TEAMS_LIST_FAIL";

export const SET_CREATE_NEW_PROJECT_DATA = "SET_CREATE_NEW_PROJECT_DATA";
export const CLEAR_CREATE_NEW_PROJECT_DATA = "CLEAR_CREATE_NEW_PROJECT_DATA";

export const SET_SUBSCRIPTION_ENTITLEMENT_ERRORS =
  "SET_SUBSCRIPTION_ENTITLEMENT_ERRORS";

export const SET_WORKSPACE_LIST_DROPDOWN_VISIBLE =
  "SET_WORKSPACE_LIST_DROPDOWN_VISIBLE";

export const GET_WELCOME_PAGE_DATA = "GET_WELCOME_PAGE_DATA";
export const GET_WELCOME_PAGE_DATA_SUCCESS = "GET_WELCOME_PAGE_DATA_SUCCESS";
export const GET_WELCOME_PAGE_DATA_FAIL = "GET_WELCOME_PAGE_DATA_FAIL";
export const GET_TEAMS_FOR_WORKSPACE = "GET_TEAMS_FOR_WORKSPACE";
export const GET_TEAMS_FOR_WORKSPACE_SUCCESS =
  "GET_TEAMS_FOR_WORKSPACE_SUCCESS";
export const SET_OPEN_ADD_BRIEF_PANE_FOR_NEW_PROJECT =
  "SET_OPEN_ADD_BRIEF_PANE_FOR_NEW_PROJECT";
export const SET_LOADING_BRIEF_FOR_NEW_PROJECT =
  "SET_LOADING_BRIEF_FOR_NEW_PROJECT";
export const SET_BRIEF_DATA_FOR_NEW_PROJECT = "SET_BRIEF_DATA_FOR_NEW_PROJECT";
export const SET_BRIEF_ANALYSIS_DATA = "SET_BRIEF_ANALYSIS_DATA";
export const UPDATE_SHOW_TABLE_SEARCH = "UPDATE_SHOW_TABLE_SEARCH";
